(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["yk-featured-products"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('yk-featured-products')) {
    customElements.define('yk-featured-products', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        const groups = [...this.querySelectorAll('[data-group]')];
        const select = this.querySelector('[data-filter] select');
        const sort = this.querySelector('[data-sort]');
        const ranks = JSON.parse(this.querySelector('[data-sales-rank]').textContent);
        groups.forEach(group => {
          const track = group.querySelector('.yk-featured__track');
          [...track.children].map((item, index) => ({ item, index }))
            .sort((a, b) => (ranks[a.item.dataset.product] ?? Number.MAX_SAFE_INTEGER) - (ranks[b.item.dataset.product] ?? Number.MAX_SAFE_INTEGER) || a.index - b.index)
            .forEach(({ item }) => track.append(item));
          const fullTitle = (track.firstElementChild?.dataset.productTitle || '').trim();
          let title = fullTitle;
          if (fullTitle.startsWith('"')) title = fullTitle.slice(1).split('"')[0];
          else if (fullTitle.startsWith('“')) title = fullTitle.slice(1).split('”')[0];
          else title = fullTitle.split(' - ')[0].split(' – ')[0].split(' — ')[0].split(' | ')[0];
          title = title.trim() || group.dataset.sortTitle;
          group.querySelector('h2').textContent = title;
          group.dataset.sortTitle = title;
          track.setAttribute('aria-label', `${title} products`);
          group.querySelector('[data-direction="-1"]').setAttribute('aria-label', `Previous products in ${title}`);
          group.querySelector('[data-direction="1"]').setAttribute('aria-label', `Next products in ${title}`);
        });
        const subjects = new Map();
        const membership = new Map();
        const bestRank = new Map(groups.map(group => [group, Math.min(...[...group.querySelectorAll('[data-product]')].map(item => ranks[item.dataset.product] ?? Number.MAX_SAFE_INTEGER))]));
        const relevance = group => {
          if (!select.value) return 0;
          const products = [...group.querySelectorAll('[data-product]')];
          return products.filter(product => [...product.querySelectorAll('[data-subject-id]')].some(subject => subject.dataset.subjectId === select.value)).length / products.length;
        };
        groups.forEach(group => {
          const ids = new Set();
          group.querySelectorAll('[data-subject-id]').forEach(subject => {
            const { subjectId: id, subjectLabel: label } = subject.dataset;
            if (id && label) { ids.add(id); subjects.set(id, label); }
          });
          membership.set(group, ids);
        });
        select.length = 1;
        [...subjects].sort((a, b) => a[1].localeCompare(b[1])).forEach(([id, label]) => select.add(new Option(label, id)));
        this.querySelector('[data-filter]').hidden = false;
        const updateGroupArrows = group => {
          if (group.hidden) return;
          const track = group.querySelector('.yk-featured__track');
          const end = track.scrollWidth - track.clientWidth;
          group.querySelector('[data-direction="-1"]').disabled = track.scrollLeft <= 2;
          group.querySelector('[data-direction="1"]').disabled = track.scrollLeft >= end - 2;
        };
        const updateArrows = () => {
          groups.forEach(updateGroupArrows);
          this.querySelectorAll('.yk-featured__item img[src]').forEach(image => {
            const width = Math.ceil(image.parentElement.getBoundingClientRect().width);
            if (width && image.sizes !== `${width}px`) image.sizes = `${width}px`;
          });
        };
        const filter = () => {
          let count = 0;
          groups.forEach(group => {
            group.hidden = Boolean(select.value && !membership.get(group).has(select.value));
            if (!group.hidden) count++;
          });
          const productCount = new Set(groups.filter(group => !group.hidden).flatMap(group => [...group.querySelectorAll('[data-product]')].map(product => product.dataset.product))).size;
          this.querySelector('[data-count]').textContent = `${productCount.toLocaleString('en')} products · ${count} product groups`;
          this.querySelector('[data-empty]').hidden = count > 0;
          requestAnimationFrame(updateArrows);
        };
        select.addEventListener('change', () => {
          if (sort.value === 'most-relevant') sort.dispatchEvent(new Event('change'));
          else filter();
        }, options);
        this.querySelector('[data-sort-control]').hidden = false;
        sort.addEventListener('change', () => {
          const [key, direction] = sort.value.split('-');
          const multiplier = direction === 'descending' ? -1 : 1;
          const ordered = groups.map((group, index) => ({ group, index }));
          ordered.sort((a, b) => {
            let difference = 0;
            if (sort.value === 'best-selling') difference = bestRank.get(a.group) - bestRank.get(b.group);
            if (sort.value === 'most-relevant') difference = relevance(b.group) - relevance(a.group);
            if (key === 'title') difference = a.group.dataset.sortTitle.localeCompare(b.group.dataset.sortTitle, 'en', { sensitivity: 'base', numeric: true });
            if (key === 'price') difference = Number(a.group.dataset.sortPrice) - Number(b.group.dataset.sortPrice);
            if (key === 'created') difference = Number(a.group.dataset.sortCreated) - Number(b.group.dataset.sortCreated);
            return difference * multiplier || a.index - b.index;
          });
          const container = this.querySelector('.yk-featured__groups');
          ordered.forEach(({ group }) => container.append(group));
          filter();
        }, options);
        groups.forEach(group => {
          const track = group.querySelector('.yk-featured__track');
          group.querySelector('[data-arrows]').hidden = false;
          track.addEventListener('scroll', () => updateGroupArrows(group), { ...options, passive: true });
          group.querySelectorAll('[data-direction]').forEach(button => button.addEventListener('click', () => {
            track.scrollBy({ left: Number(button.dataset.direction) * track.clientWidth, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
          }, options));
          track.addEventListener('keydown', event => {
            if (event.target !== track || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
            event.preventDefault();
            const left = event.key === 'Home' ? 0 : event.key === 'End' ? track.scrollWidth : track.scrollLeft + (event.key === 'ArrowLeft' ? -1 : 1) * track.clientWidth;
            track.scrollTo({ left, behavior: 'instant' });
          }, options);
        });
        this.observer = new ResizeObserver(updateArrows);
        this.observer.observe(this);
        sort.dispatchEvent(new Event('change'));
        this.imageObserver = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (!entry.isIntersecting) return;
            const image = entry.target.querySelector('img[data-group-src]');
            if (image) {
              const width = Math.ceil(image.parentElement.getBoundingClientRect().width) || 400;
              image.sizes = `${width}px`;
              image.loading = 'eager';
              image.decoding = 'async';
              if (image.dataset.groupSrcset) image.srcset = image.dataset.groupSrcset;
              image.src = image.dataset.groupSrc;
              delete image.dataset.groupSrc;
              delete image.dataset.groupSrcset;
            }
            this.imageObserver.unobserve(entry.target);
          });
        }, { rootMargin: '150px' });
        this.querySelectorAll('.yk-featured__item').forEach(item => this.imageObserver.observe(item));
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
        this.observer?.disconnect();
        this.imageObserver?.disconnect();
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
